import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';

@Entity()
export class MeetingLink extends AdornisEntity {
  static override _class = 'MeetingLink';

  @validate(options => {
    if (!options.value.startsWith('https://') && !options.value.startsWith('http://'))
      throw new ValidationError('Geben Sie eine gültige URL ein');
  })
  @Field(type => String)
  link!: string;
}

@Entity()
export class ZoomMeetingLink extends MeetingLink {
  static override _class = 'ZoomMeetingLink';

  @Field(type => String)
  ownerID!: Maybe<string>;
}
